
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashCouponTypeDialog extends Serenity.EntityDialog<PsCashCouponTypeRow, any> {
        protected getFormKey() { return PsCashCouponTypeForm.formKey; }
        protected getIdProperty() { return PsCashCouponTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsCashCouponTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsCashCouponTypeRow.nameProperty; }
        protected getService() { return PsCashCouponTypeService.baseUrl; }
        protected getDeletePermission() { return PsCashCouponTypeRow.deletePermission; }
        protected getInsertPermission() { return PsCashCouponTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsCashCouponTypeRow.updatePermission; }

        protected form = new PsCashCouponTypeForm(this.idPrefix);

        constructor() {
            super();

            

            this.form.CashCouponValueType.change(e => {
                var isPsCashCouponValueType = this.psCashCouponValuetype;
                var isPsCashCouponValueType1 = this.psCashCouponValuetype1;

                if(!isPsCashCouponValueType1) {
                    Serenity.EditorUtils.setReadOnly(this.form.CashCouponValue, isPsCashCouponValueType1);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensateAmt, isPsCashCouponValueType1);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, !isPsCashCouponValueType1);
                } 
                else if(!isPsCashCouponValueType) {
                    Serenity.EditorUtils.setReadOnly(this.form.CashCouponValue, isPsCashCouponValueType1);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensateAmt, isPsCashCouponValueType1);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, !isPsCashCouponValueType);
                }
            });
        }

        private get psCashCouponValuetype() {
            return this.form.CashCouponValueType.value != CashCouponValueType.ValueType.toString();
        }

        private get psCashCouponValuetype1() {
            return this.form.CashCouponValueType.value != CashCouponValueType.ValueType1.toString();
        }

        
    }
}